<template>
  <div id="TCsSpark" class="container-fluid px-0 privacy-policy">
    <header class="page-header">
      <div class="d-flex flex-column align-items-center">
        <img src="/img/spectrum_life_logo_light.png" class="logo" alt="logo" />
        <h2 class="mb-0 header">Terms of Use for Service</h2>
      </div>
    </header>
    <main class="content">
      <div class="content-card">
        <TCsSparkContent />
      </div>
    </main>
    <footer>
      <Footer v-if="$store.state.user.authenticated"></Footer>
    </footer>
  </div>
</template>

<script>
import Footer from "../components/Footer";
import TCsSparkContent from "../components/TCsSparkContent.vue";

export default {
  name: "TCsSpark",
  components: {
    TCsSparkContent,
    Footer,
  },
};
</script>
<style lang="less">
#TCsSpark {
  background-color: #fbfafa;
  color: #000;

  h3 {
    font-size: 2rem;
    color: #000 !important;
    font-family: "DMSans Bold", sans-serif;
    margin-bottom: 16px;
  }

  section {
    margin-bottom: 40px;
  }

  .page-header {
    padding: 60px 20px 20px;
    color: #000;
  }

  td {
    border: 1px solid black !important;
    padding: 3px;
  }

  strong {
    font-family: "DMSans Bold", sans-serif;
  }

  font-size: 1.6rem;
  font-family: "DMSans", sans-serif;

  label {
    margin-bottom: 0;
  }

  .logo {
    max-width: 350px;
    width: 100%;
    padding-bottom: 50px;
  }

  .header {
    text-align: center;
    font-size: 3.8rem;
    letter-spacing: normal;
    color: #000000;
  }

  .content {
    padding: 20px 20px 60px;
  }

  .content-card {
    height: 100%;
    background: #ffffff;
    max-width: 1000px;
    padding: 40px 60px 30px;
    margin: 0 auto;
    border-radius: 16px;
    overflow-x: scroll;
    color: #000000;
    p,
    li {
      color: #000000;
    }
  }

  @media only screen and (max-width: 768px) {
    .content-card {
      padding: 20px;
    }
  }
}
</style>
